import { createReducer } from '@reduxjs/toolkit'

import { TShowNPS } from 'types/GlobalNPS'

import * as actions from '../../actions/NPS/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

const INITIAL_STATE: TShowNPS = {
  show: false,
  refetch: false
}

const NPSReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.setShowNps, (_, action) => action.payload)
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default NPSReducer
